import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { buttons as Buttons } from '@breezeway/brzw-components';
import { Fields } from 'redux-form';
import _ from 'lodash';

import { EMPTY_PHONE_NUMBER_OBJECT } from '@common/utils/messenger/constants';
import FormRadioToggle from '../../form_radio_toggle';
import FormArrayPhoneFieldControl from './form-array-phone-field-control';
import './form_array_phone_numbers_control.scss';

const PRIMARY_OPTIONS = [{ value: true, label: 'Primary' }];
const CLASS_NAME = 'form-array-phone-numbers-control';

const FormArrayPhoneNumbersControl = ({
  classNameContainer,
  fields,
  formValues,
  inputWrapperClassName,
  meta: { error, submitFailed },
  onChangePrimaryCheckboxOption,
  required,
}) => (
  <div className={classnames(classNameContainer, CLASS_NAME, 'form-group-row d-flex flex-row')}>
    <div
      className={classnames(
        inputWrapperClassName,
        `${CLASS_NAME}__container`,
        'form-group-row__input-wrapper d-flex',
      )}
    >
      <div className={`${CLASS_NAME}__container-fields`}>
        {error && submitFailed && <p className={`${CLASS_NAME}__primary-field-error`}>{error}</p>}
        {fields.map((phoneNumber, index) => (
          <Fragment key={`form-array-control-field-item-${index}-${fields.length}`}>
            <Fields
              component={FormArrayPhoneFieldControl}
              names={[
                `${phoneNumber}.country_code`,
                `${phoneNumber}.dial_code`,
                `${phoneNumber}.phone_number`,
                `${phoneNumber}.type_contact_object`,
              ]}
              required={required}
              preferredCountries={['us']}
            />
            <div className={`${CLASS_NAME}__controls-wrapper`}>
              <FormRadioToggle
                inputs={PRIMARY_OPTIONS}
                name={`${phoneNumber}.primary`}
                onClick={() => onChangePrimaryCheckboxOption(fields, index)}
                value={_.get(formValues, `${phoneNumber}.primary`, false)}
              />
              <Buttons.TextButton
                autoWidth
                className={`${CLASS_NAME}__delete-btn`}
                size={Buttons.constants.BUTTON_SIZES.SMALL}
                theme={Buttons.constants.BUTTON_THEMES.LINK}
                onClick={() => fields.remove(index)}
              >
                Remove
              </Buttons.TextButton>
            </div>
          </Fragment>
        ))}
      </div>
      <Buttons.TextButton
        className={`${CLASS_NAME}__container-button`}
        onClick={() => fields.push({ ...EMPTY_PHONE_NUMBER_OBJECT, primary: fields.length === 0 })}
        size={Buttons.constants.BUTTON_SIZES.LARGE}
        theme={Buttons.constants.BUTTON_THEMES.LINK}
      >
        Add Another Phone Number
      </Buttons.TextButton>
    </div>
  </div>
);

FormArrayPhoneNumbersControl.propTypes = {
  classNameContainer: PropTypes.string,
  fields: PropTypes.shape({}),
  formValues: PropTypes.shape({}),
  inputWrapperClassName: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.string,
    submitFailed: PropTypes.bool,
  }),
  onChangePrimaryCheckboxOption: PropTypes.func,
  required: PropTypes.bool,
};

FormArrayPhoneNumbersControl.defaultProps = {
  classNameContainer: '',
  required: false,
};

export default FormArrayPhoneNumbersControl;
